import axios from 'axios';
import { makeApiUrl } from '../../../../shared/util';
import { PopupWithStatus } from '@services/MarppleShop/features/Popup/type';

function parsePopupLinkUrl(link_url: string | undefined, domain_name: string): string | undefined {
  // 빈 문자열이나 null/undefined 체크
  if (!link_url || link_url.trim() === '') {
    return undefined;
  }

  const trimmed_url = link_url.trim();

  // 풀 URL 체크 (http:// 또는 https://로 시작)
  if (trimmed_url.startsWith('http://') || trimmed_url.startsWith('https://')) {
    return trimmed_url;
  }

  // 부분 URL 체크 (슬래시로 시작)
  if (trimmed_url.startsWith('/')) {
    return `/${ET.lang}/${domain_name}${trimmed_url}`;
  }

  // 둘 다 해당하지 않으면 undefined 반환
  return undefined;
}

export const getStudioPopups = async (store_id: number, domain_name: string): Promise<PopupWithStatus[]> => {
  const { data: popups } = await axios.get<PopupWithStatus[]>(
    makeApiUrl(`/${ET.lang}/@api/stores/:store_id/popups`, { store_id }),
  );

  return popups.map((popup) => {
    // 스튜디오 전용 url 로 파싱
    return {
      ...popup,
      link_url: parsePopupLinkUrl(popup.link_url, domain_name),
    };
  });
};
